import React from "react";
import { useParams, Link } from "react-router-dom";
import { blogs } from "../data/blogsData";
import { Helmet } from "react-helmet-async";
const BlogSingle = () => {

  const { slug } = useParams();

  // ✅ HOOKS ALWAYS FIRST
  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
    mobile: "",
    institute: ""
  });

  const blog = blogs.find((b) => b.slug === slug);

  // ✅ THEN CONDITIONS
  if (!blog) {
    return <div className="p-20 text-center">Blog Not Found</div>;
  }
  const sendToWhatsApp = () => {

    const phoneNumber = "919254147455"; // 🔴 CHANGE TO YOUR NUMBER

    const message =
`Hello, I want to talk to Gurukul ERP expert.

Name: ${formData.name}
Email: ${formData.email}
Mobile: ${formData.mobile}
Institute: ${formData.institute}`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };

  // ===== Extract headings =====
  const headings = blog.content.filter((c) => c.type === "h2");

  // ===== Related Posts =====
  const relatedPosts = blogs
    .filter((b) => b.slug !== blog.slug)
    .slice(0, 3);

  // ===== SEO Slug ID Generator =====
  const createId = (text) =>
    text.toLowerCase().replace(/[^\w\s]/gi, "").replace(/\s+/g, "-");

  return (
    <main className="bg-[#f7f8fc] min-h-screen scroll-smooth">

      <Helmet>

  {/* TITLE TAG */}
  <title>{blog.title} | Gurukul ERP Blogs</title>

  {/* META DESCRIPTION */}
  <meta
    name="description"
    content={blog.desc || "Gurukul ERP Blog for School Management, Attendance, Fees and Digital ERP Solutions."}
  />

  {/* KEYWORDS (optional but ok) */}
  <meta
    name="keywords"
    content={`${blog.category}, school erp, gurukul erp, education software`}
  />

  {/* OPEN GRAPH (Facebook SEO) */}
  <meta property="og:title" content={blog.title} />
  <meta property="og:description" content={blog.desc} />
  <meta property="og:image" content={blog.image} />
  <meta property="og:type" content="article" />

  {/* TWITTER SEO */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={blog.title} />
  <meta name="twitter:description" content={blog.desc} />
  <meta name="twitter:image" content={blog.image} />

</Helmet>

      {/* ================= BLOG SECTION ================= */}
      <div className="max-w-[1400px] mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-[240px_1fr] xl:grid-cols-[220px_minmax(780px,1fr)_280px] gap-10">

        {/* ================= CONTENTS ================= */}
        <aside className="order-1 md:order-none">
          <nav className="bg-[#f3e4d7] rounded-2xl p-6 md:sticky md:top-24">
            <h2 className="font-semibold text-lg mb-4">Contents</h2>

            <ul className="space-y-3 text-sm text-gray-800">
              {headings.map((h, i) => (
                <li key={i}>
                  <a
                    href={`#${createId(h.text)}`}
                    className="hover:text-orange-500 transition block"
                  >
                    {h.text}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        {/* ================= CENTER BLOG ================= */}
        <article className="bg-white rounded-3xl shadow-sm p-8">

          {/* Breadcrumb */}
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/" className="hover:text-orange-500">Home</Link> /
            <Link to="/blogs" className="hover:text-orange-500 ml-1">Blog</Link> /
            <span className="ml-1">{blog.title}</span>
          </nav>

          {/* H1 */}
          <h1 className="text-3xl lg:text-4xl font-bold text-gray-800">
            {blog.title}
          </h1>

          <p className="text-orange-500 font-medium mt-3">
            {blog.category}
          </p>

          <div className="flex justify-between items-center mt-4 flex-wrap gap-3">
            <p className="text-sm text-gray-500">
              {blog.date} • {blog.readTime}
            </p>

            <div className="flex gap-3 text-gray-400">

  <button
    onClick={async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        alert("Link copied!");
      } catch (error) {
        alert("Copy failed");
      }
    }}
    className="hover:text-orange-500"
    title="Copy Link"
  >
    🔗
  </button>

  <a
    href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(blog.title)}`}
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-blue-500"
  >
    🐦
  </a>

  <a
    href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`}
    target="_blank"
    rel="noopener noreferrer"
    className="hover:text-blue-700"
  >
    in
  </a>

</div>
          </div>

          {/* Image */}
          <img
            src={blog.image}
            alt={blog.title}
            className="rounded-2xl my-8 w-full"
            loading="lazy"
          />

          {/* ===== Premium Reading Layout ===== */}
          <section
            className="
              max-w-[780px] mx-auto
              text-[17px] leading-[1.85]
              text-gray-700
              space-y-7
              tracking-[0.2px]
            "
          >
            {blog.content.map((block, i) => {

              if (block.type === "h2") {
                return (
                  <h2
                    id={createId(block.text)}
                    key={i}
                    className="text-[28px] font-semibold text-gray-900 mt-14 mb-4 leading-tight scroll-mt-28"
                  >
                    {block.text}
                  </h2>
                );
              }

              return (
  <p
    key={i}
    className="blog-paragraph"
    dangerouslySetInnerHTML={{ __html: block.text }}
  />
);
            })}
          </section>

        </article>

        {/* ================= CONTACT FORM ================= */}
        <aside className="hidden xl:block">
          <div className="bg-[#f3e4d7] rounded-2xl p-6 sticky top-24">
            <h2 className="text-xl font-semibold mb-5">
              Get in Touch
            </h2>

            <input
              placeholder="Enter Your Name"
              value={formData.name}
              onChange={(e)=>setFormData({...formData, name:e.target.value})}
              className="w-full border rounded-xl px-4 py-3 mb-3 outline-none"
            />

            <input
              placeholder="Enter Your Email"
              value={formData.email}
              onChange={(e)=>setFormData({...formData, email:e.target.value})}
              className="w-full border rounded-xl px-4 py-3 mb-3 outline-none"
            />

            <input
              placeholder="+91 Mobile Number"
              value={formData.mobile}
              onChange={(e)=>setFormData({...formData, mobile:e.target.value})}
              className="w-full border rounded-xl px-4 py-3 mb-3 outline-none"
            />

            <input
              placeholder="Enter School Name"
              value={formData.institute}
              onChange={(e)=>setFormData({...formData, institute:e.target.value})}
              className="w-full border rounded-xl px-4 py-3 mb-5 outline-none"
            />

            <button
              onClick={sendToWhatsApp}
              className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-xl font-semibold transition"
            >
              Talk to expert
            </button>

          </div>
        </aside>

      </div>

      {/* ================= RELATED POSTS ================= */}
      {relatedPosts.length > 0 && (
        <section className="w-full bg-white py-20">

          <div className="max-w-[1400px] mx-auto px-6">

            <div className="mb-10 border-b pb-4">
              <h2 className="text-2xl font-semibold text-gray-800">
                Related Posts
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-8">
              {relatedPosts.map((post) => (
                <Link key={post.id} to={`/blogs/${post.slug}`} className="group h-full">

                  <article className="bg-white rounded-3xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col h-full hover:-translate-y-1">

                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-56 object-cover"
                      loading="lazy"
                    />

                    <div className="p-6 flex flex-col flex-grow">
                      <h3 className="text-lg font-semibold text-gray-800 group-hover:text-orange-500 transition">
                        {post.title}
                      </h3>

                      <p className="text-orange-500 text-sm mt-3">
                        {post.category}
                      </p>

                      <p className="mt-auto pt-4 text-sm text-gray-500">
                        {post.date} • {post.readTime}
                      </p>
                    </div>

                  </article>

                </Link>
              ))}
            </div>

          </div>
        </section>
      )}

    </main>
  );
};

export default BlogSingle;